/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Subscribetonotifications2Inputs */

const id_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlangganan ke Notifikasi`)
};

const ms_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langgan Pemberitahuan`)
};

const da_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonner på Notifikationer`)
};

const de_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen abonnieren`)
};

const en_us2_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Notifications`)
};

const es_es2_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse a notificaciones`)
};

const es_mx2_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse a notificaciones`)
};

const fil_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-subscribe sa mga Notipikasyon`)
};

const fr_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'abonner aux notifications`)
};

const it_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti alle notifiche`)
};

const hu_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feliratkozás az értesítésekre`)
};

const nl_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonneren op meldingen`)
};

const no_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonner på varsler`)
};

const pl_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrybuj powiadomienia`)
};

const pt_br2_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Notifications`)
};

const pt_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscrever notificações`)
};

const ro_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonează-te la notificări`)
};

const fi_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilaa ilmoitukset`)
};

const sv_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumerera på notiser`)
};

const vi_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký nhận thông báo`)
};

const tr_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimlere Abone Ol`)
};

const cs_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit se k oznámením`)
};

const bg_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абониране за известия`)
};

const ru_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписаться на уведомления`)
};

const uk_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписатися на сповіщення`)
};

const ar_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتراك في الإشعارات`)
};

const hi_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाओं की सदस्यता लें`)
};

const th_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครรับการแจ้งเตือน`)
};

const ja_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知を購読`)
};

const zh_cn2_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Notifications`)
};

const zh_hant1_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Notifications`)
};

const ko_notifications_simple_subscribetonotifications2 = /** @type {(inputs: Notifications_Simple_Subscribetonotifications2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림 구독`)
};

/**
* | output |
* | --- |
* | "Subscribe to Notifications" |
*
* @param {Notifications_Simple_Subscribetonotifications2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_subscribetonotifications2 = /** @type {((inputs?: Notifications_Simple_Subscribetonotifications2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Subscribetonotifications2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "ms") return ms_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "da") return da_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "de") return de_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "fil") return fil_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "fr") return fr_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "it") return it_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "hu") return hu_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "nl") return nl_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "no") return no_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "pl") return pl_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "pt") return pt_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "ro") return ro_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "fi") return fi_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "sv") return sv_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "vi") return vi_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "tr") return tr_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "cs") return cs_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "bg") return bg_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "ru") return ru_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "uk") return uk_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "ar") return ar_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "hi") return hi_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "th") return th_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "ja") return ja_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_subscribetonotifications2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_subscribetonotifications2(inputs)
	return ko_notifications_simple_subscribetonotifications2(inputs)
});
export { notifications_simple_subscribetonotifications2 as "notifications.simple.subscribeToNotifications" }